import { TFunction } from "i18next"
import { nanoid } from "nanoid"
import { ImageArticuloBodyTemplate } from "../templates"

export const catalogosColumns = (t: $TSMigrationFixMe) => [
  {
    key: nanoid(),
    header: `${t("catalogos.table.headerName")}`,
    field: "nombre",
    sortable: true,
  },
  {
    key: nanoid(),
    header: `${t("catalogos.table.headerNArticles")}`,
    field: "cantidadArticulos",
    sortable: true,
    headerStyle: {
      align: "center",
    },
  },
  {
    key: nanoid(),
    header: "",
    field: "imagenBase64",
    body: ImageArticuloBodyTemplate,
    headerStyle: {
      width: "auto",
    },
    className: "tw-flex tw-justify-end !tw-px-6",
  },
]

export const CATALOGOS_COLUMNS = (t: TFunction) => [
  {
    key: "nombre",
    field: "nombre",
    header: `${t("catalogos.table.headerName")}`,
    sortable: false,
    style: { width: "40%" },
  },
  {
    key: "cantidadArticulos",
    field: "cantidadArticulos",
    header: `${t("catalogos.table.headerNArticles")}`,
    sortable: false,
    style: { width: "30%" },
  },
  {
    key: "imagenBase64",
    field: "imagenBase64",
    body: ImageArticuloBodyTemplate,
    sortable: false,
    style: { width: "8%" },
  },
]
